const StartEle=()=>{
    return (<sup className="important-star" style={{ color: "red" }}>*</sup>);
}
export default StartEle;